import React from 'react'
import PropTypes from 'prop-types'
import { getText } from '../../../../../internal/TextLabels'
import { EmailOrPhoneLink } from './EmailOrPhoneLink'

export const DelayedPaymentSignPageUI = props => (
  <>
    <h5>{getText('payApply.sign.delayedPayment.title')}</h5>
    <p>{getText('payApply.sign.delayedPayment.description')}</p>
    <EmailOrPhoneLink
      {...props}
      phoneNumber={props.customer.mobile}
      email={props.customer.email}
      onChange={props.onChange}
    />
    {props.children}
  </>
)

DelayedPaymentSignPageUI.propTypes = {
  customer: PropTypes.object.isRequired,
  onChange: PropTypes.func,
}

DelayedPaymentSignPageUI.defaultProps = {
  onChange: () => {},
}
